import styles from "./AwardItem.module.scss";
import Typography from "@mui/material/Typography";
import PaidIcon from "@mui/icons-material/Paid";
import Button from "@mui/material/Button";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Tag } from "antd";
const AwardItem = ({ data }) => {
  return (
    <div className={styles["award"]}>
      <div
        className={styles["title"]}
        onClick={() => {
          if (data.award_url) {
            window.open(data.award_url);
          }
        }}
      >
        <span style={{ fontWeight: "600" }}>{data.award_title}</span>
        {data.program_title !== "None" && (
          <span className={styles["venue"]}>
            <i>. {data.program_title}</i>
          </span>
        )}
      </div>
      <div className={styles["award-number"]}>
        <span>
          <span className={styles["section-title"]}>Award number:</span>
          <span style={{ fontStyle: "italic" }}>
            {" "}
            {data.award_number}
          </span>.{" "}
        </span>
        <span style={{ color: "var(--explore-color)", fontWeight: "500" }}>
          {data.start_date} / {data.end_date}
        </span>
      </div>

      <div className={styles["sponsors"]}>
        <span className={styles["section-title"]}>Sponsors:</span>{" "}
        {data.sponsors &&
          data.sponsors.map((item, index) => {
            return <span key={index}>{item["#text"]}; </span>;
          })}
      </div>
      <div className={styles["coauthors"]}>
        <span className={styles["section-title"]}>
          Principal investigators:
        </span>{" "}
        {data.principal_investigators}
      </div>
      <div className={styles["tags"]}>
        {data.keywords.map((item, index) => {
          return (
            <Tag key={index} color="blue" style={{ cursor: "pointer" }}>
              {item.id}
            </Tag>
          );
        })}
      </div>
      {/* {!!data.amount_awarded && (
        <div className={styles["action"]}>
          <Button
            style={{
              backgroundColor: "white",
              color: "#b45f06",
              borderRadius: 10,
              height: 25,
              paddingLeft: 0,
              textAlign: "left",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            <PaidIcon />
            <Typography align={"left"} style={{ fontSize: 12 }}>
              {numberRegex(parseFloat(data.amount_awarded))}
            </Typography>
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default AwardItem;
